var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnpublishIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 78C60.5391 78 78 60.5391 78 39C78 17.4609 60.5391 0 39 0C17.4609 0 0 17.4609 0 39C0 60.5391 17.4609 78 39 78Z",
    fill: "url(#paint0_linear_630_55948)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6082 48.4668H23.0676C20.8246 48.4668 19 50.289 19 52.529V57.9453C19 60.1854 20.8246 62.0076 23.0676 62.0076H55.6082C57.8512 62.0076 59.6758 60.1854 59.6758 57.9453V52.529C59.6758 50.289 57.8512 48.4668 55.6082 48.4668ZM25.7793 56.5911C25.0305 56.5911 24.4234 55.9848 24.4234 55.237C24.4234 54.4891 25.0305 53.8829 25.7793 53.8829C26.5281 53.8829 27.1352 54.4891 27.1352 55.237C27.1352 55.9848 26.5281 56.5911 25.7793 56.5911ZM31.2027 56.5911C30.454 56.5911 29.8469 55.9848 29.8469 55.237C29.8469 54.4891 30.454 53.8829 31.2027 53.8829C31.9515 53.8829 32.5586 54.4891 32.5586 55.237C32.5586 55.9848 31.9515 56.5911 31.2027 56.5911ZM36.6262 56.5911C35.8774 56.5911 35.2703 55.9848 35.2703 55.237C35.2703 54.4891 35.8774 53.8829 36.6262 53.8829C37.3749 53.8829 37.982 54.4891 37.982 55.237C37.982 55.9848 37.3749 56.5911 36.6262 56.5911Z",
    fill: "url(#paint1_linear_630_55948)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3557 29.5103H35.4233V38.9887C35.4233 39.7372 36.0297 40.3427 36.7791 40.3427H42.2026C42.9519 40.3427 43.5584 39.737 43.5584 38.9887V29.5102H47.626C48.1397 29.5102 48.6085 29.2206 48.8388 28.7617C49.0679 28.3029 49.0189 27.7541 48.7104 27.3442L40.5752 16.5118C40.0641 15.8294 38.9174 15.8294 38.4065 16.5118L30.2713 27.3442C29.9628 27.7541 29.9138 28.3029 30.1429 28.7617C30.3732 29.2207 30.842 29.5103 31.3557 29.5103ZM42.2026 43.051H36.7791C36.0297 43.051 35.4233 43.6565 35.4233 44.405C35.4233 45.1535 36.0297 45.759 36.7791 45.759H42.2026C42.9519 45.759 43.5584 45.1533 43.5584 44.405C43.5584 43.6565 42.9519 43.051 42.2026 43.051Z",
    fill: "url(#paint2_linear_630_55948)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_630_55948",
    x1: 39,
    y1: 78,
    x2: 39,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_630_55948",
    x1: 39.3376,
    y1: 69.401,
    x2: 39.3376,
    y2: 48.4668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_630_55948",
    x1: 39.4907,
    y1: 62.0079,
    x2: 39.4907,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpublishIcon);
export default __webpack_public_path__ + "static/media/unpublish-icon.082b2cc53210b0cf0b1e14225840dadd.svg";
export { ForwardRef as ReactComponent };